import {
    getComputedVariantProduct as baseGetComputedVariantProduct,
    getProductState,
    getProductStateByPath,
} from "@insite/client-framework/Store/Data/Products/ProductsSelectors";

export const getComputedVariantProduct = (
    parentProductState: ReturnType<typeof getProductStateByPath>,
    variantProductState: ReturnType<typeof getProductState>,
) => {
    const productDataView = baseGetComputedVariantProduct(parentProductState, variantProductState);

    if (productDataView === parentProductState) {
        return productDataView;
    }

    const { value: variantProduct } = variantProductState;

    ["properties"].forEach(x => {
        const variantValue = (variantProduct as any)?.[x];
        if (variantValue) {
            (productDataView as any).value[x] = variantValue;
        }
    });

    return productDataView;
};
